/**
 * Process
 */
export class Process {
    /** actionType */
    public actionType: string;
    /** processId */
    public processId: string;
    /** parameters */
    public parameters: object;
    /** stepName */
    public stepName: string;

    public constructor (actionType: string,
        processId: string,
        stepName?: string,
        parameters?: object,
    ) {
        this.actionType = actionType;
        this.processId = processId;
        this.parameters = parameters;
        this.stepName = stepName;

    }
}
